__webpack_require__.p = "https://admin.bobeelight.com.tw/";